import { graphql } from 'graphql-schema';
// Shared queries that are not handled in the SCL (for components per platform)
export const HASURA_DISCOVER_TOP_NEIGHBORHOODS = graphql(`
  query GetTopNeighborhoods($where: leagues_bool_exp!) {
    neighborhoods(
      where: { leagues: $where }
      order_by: { leagues_aggregate: { count: desc } }
      limit: 5
    ) {
      _id
      name
    }
  }
`);
export const HASURA_DISCOVER_TOP_SPORTS = graphql(`
  query GetDiscoverTopSports($where: leagues_bool_exp!) {
    sports(where: { leagues: $where }, order_by: { leagues_aggregate: { count: desc } }) {
      _id
      name
    }
  }
`);
export const HASURA_DISCOVER_TOP_VENUES = graphql(`
  query GetTopVenues($where: leagues_bool_exp!) {
    venues(where: { leagues: $where }, order_by: { leagues_aggregate: { count: desc } }, limit: 5) {
      _id
      shorthand_name
    }
  }
`);
export const HASURA_DISCOVER_PROGRAM_TYPES = graphql(`
  query discoverPrograms($where: leagues_bool_exp!) {
    leagues(where: $where, distinct_on: [program_type], order_by: [{ program_type: asc }]) {
      _id
      program_type
    }
  }
`);
export const HASURA_DISCOVER_SEASONS = graphql(`
  query discoverSeasons($where: leagues_bool_exp!) {
    leagues(where: $where, distinct_on: [season], order_by: [{ season: asc }]) {
      _id
      season: seasonBySeason {
        _id
        name
        order
      }
    }
  }
`);
